import { Playground } from 'docz';
import { Message } from "../../../../../src/components/Elements";
import * as React from 'react';
export default {
  Playground,
  Message,
  React
};